import {generalRequest} from "@/lib/services/requests";
import {useQuery} from "@tanstack/react-query";

export function useApiMainInfo(args) {
    return useQuery({
        queryKey: ['main', 'info'],
        queryFn: () => ((async (data = {}) => {
            return generalRequest.get(`/info`, {params: data});
        })(args))
    })
}
